import { useFormatter, useTranslations } from "next-intl";
import { useState } from "react";

import Button from "~/components/common/button";
import { useAuthContext } from "~/contexts/auth";
import { useConfiguration } from "~/contexts/configuration";
import loyaltyUtils from "~/utils/loyalty-utils";

import QRCodeDialog from "../qrcode-dialog";
import styles from "./data-level-bar.module.scss";
import LoyaltyProgress from "./loyalty-progress";

export function PointsToCollect() {
  const t = useTranslations();

  return (
    <div className={styles.pointsToCollectWrapper}>
      {/* TODO we need array containing the names and discounts ids of all levels, so we can loop throught them and display the below information */}
      {/* TODO here goes a for loop with all the levels that user still have to reach */}
      <p className={styles.pointsToCollect}>
        {t.rich("generic.pointsToCollectToReachLevel", {
          points: 0,
          levelName: "creative",
          br: (chunks) => <br></br>,
          pointscontainer: (chunks) => <span className={styles.bold}>{chunks}</span>,
        })}
      </p>
    </div>
  );
}

export default function DataLavelBar() {
  const t = useTranslations();
  const formatter = useFormatter();
  const { user } = useAuthContext();
  const { configuration } = useConfiguration();
  const [qrCodeDialogOpen, setQRCodeDialogOpen] = useState<boolean>(false);

  //FIXME 1 year from now until the data is correctly read from the user
  const tierName = loyaltyUtils.getUserLoyaltyTierName(user, configuration);
  const tierExpirationDate = loyaltyUtils.getUserLoyaltyTierExpirationDate(user, configuration)
    ? formatter.dateTime(new Date(loyaltyUtils.getUserLoyaltyTierExpirationDate(user, configuration)!), {
        dateStyle: "full",
      })
    : t("error.noTierExpirationDate");

  return (
    <>
      <div className={styles.container}>
        <LoyaltyProgress />
        <div className={styles.myLevelAndMyAnniversaryWrapper}>
          <div className={styles.myLevelWrapper}>
            <p className={styles.text}>{t("generic.myLevel")}</p>
            <p className={styles.gradient}>{tierName || t("loyalty.basicLevel")}</p>
          </div>
          <div className={styles.myAnniversaryWrapper}>
            <p className={styles.text}>{t("generic.myAnniversaryDate")}</p>
            <p className={styles.gradient}>{tierExpirationDate}</p>
          </div>
          <div className={styles.myAnniversaryWrapper}>
            <Button variant="secondary" onClick={() => setQRCodeDialogOpen(true)}>
              {t("generic.dashboard.showQRCode")}
            </Button>
          </div>
          {/* TODO temporarly hidden by agreement taken on 2023/09/06 */}
          {/* {breakpoint === "desktop" ? <PointsToCollect /> : null} */}
        </div>
      </div>
      {/* TODO temporarly hidden by agreement taken on 2023/09/06 */}
      {/* {breakpoint === "mobile" ? <PointsToCollect /> : null} */}
      <QRCodeDialog isOpen={qrCodeDialogOpen} onClose={() => setQRCodeDialogOpen(false)} />
    </>
  );
}
